// WebsiteTech.pro — "What's New" feed. Newest first. `to` links to the tool/page.
export const WHATS_NEW = [
  { date: "2026-07-15", tag: "Launch", title: "Tools & Packages catalog", to: "/tools",
    desc: "Browse every WebsiteTech tool in one place — buy once, embed on your existing site, or subscribe to a managed plan." },
  { date: "2026-07-15", tag: "AI", title: "Embeddable AI Assistant — add it to any site", to: "/embed",
    desc: "Customize a branded assistant, copy one line of code, and paste it into WordPress, Wix, Shopify or any site. No rebuild." },
  { date: "2026-07-14", tag: "Launch", title: "WebsiteTech Growth Agent", to: "/growth-agent",
    desc: "Our flagship human-supervised agent that audits, plans and improves your site continuously — with Recommend / Approval / Trusted-automation modes and a full work log." },
  { date: "2026-07-12", tag: "Demos", title: "Two new demo sites: Cedar Grove College & Nexora", to: "/demos",
    desc: "Higher-ed and SaaS join the showcase — now 14 live industry demos, each with its own AI Assistant." },
  { date: "2026-07-10", tag: "Demos", title: "Live demos now on the India & Kerala homepages", to: "/demos",
    desc: "Regional visitors can explore matching demo sites and jump straight into the AI Assistant closest to their business." },
  { date: "2026-07-08", tag: "Leads", title: "Demo Leads dashboard", to: "/tools",
    desc: "See every enquiry and booking captured by your AI Assistants, filterable by industry, with the exact page each lead came from." },
  { date: "2026-07-05", tag: "AI", title: "Voice Assistant & AI appointment booking", to: "/demos",
    desc: "Tap-to-talk voice and in-chat booking are now part of every demo assistant." },
  { date: "2026-07-01", tag: "Payments", title: "Secure Stripe checkout in demos", to: "/demos",
    desc: "Fashion, grocery and charity demos now take real payments and donations through Stripe." },
];

export const TAG_STYLE = {
  Launch: "bg-blue-50 text-brand",
  AI: "bg-violet-50 text-violet-700",
  Demos: "bg-emerald-50 text-emerald-700",
  Leads: "bg-amber-50 text-amber-700",
  Payments: "bg-rose-50 text-rose-700",
};

export const fmtNewsDate = (s) => {
  try { return new Date(s).toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" }); }
  catch { return s; }
};
